import { useEffect } from 'react';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import LoginPage from './pages/LoginPage';
import ProblemsPage from './pages/ProblemsPage';
import PublishPage from './pages/PublishPage';
import ProblemDetailPage from './pages/ProblemDetailPage';
import BeianFooter from './components/BeianFooter';
import carpLogo from './assets/carp-logo.svg';

function RequireAuth({ children }: { children: JSX.Element }) {
  const token = localStorage.getItem('token');
  const path = useLocation().pathname;
  if (!token) return <Navigate to={`/login${path === '/' ? '' : `?next=${encodeURIComponent(path)}`}`} replace />;
  return children;
}

function Layout({ children }: { children: JSX.Element }) {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-gray-100 bg-white print:hidden">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-3">
          <a href="https://abc.wenzao.site" title="返回文灶主页"><img src={carpLogo} alt="文灶" className="h-8 w-auto" /></a>
          <Link to="/problems" className="font-bold text-gray-900">数理化 AI 解题</Link>
          <div className="ml-auto flex items-center gap-3 text-sm text-gray-600">
            {user && <span className="text-xs">额度 {user.quota}</span>}
            {user && (
              <button onClick={logout} className="text-xs text-gray-400 hover:text-gray-600">
                退出（{user.username}）
              </button>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-gray-100 bg-white py-4 print:hidden">
        <BeianFooter />
      </footer>
    </div>
  );
}

export default function App() {
  const fetchMe = useAuthStore((s) => s.fetchMe);
  useEffect(() => { fetchMe(); }, [fetchMe]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<RequireAuth><Layout><Navigate to="/problems" replace /></Layout></RequireAuth>} />
      <Route path="/problems" element={<RequireAuth><Layout><ProblemsPage /></Layout></RequireAuth>} />
      <Route path="/problems/new" element={<RequireAuth><Layout><PublishPage /></Layout></RequireAuth>} />
      <Route path="/problems/:id" element={<RequireAuth><Layout><ProblemDetailPage /></Layout></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
